import {Fab, Grid} from '@material-ui/core';
import {Link} from 'react-router-dom';
import {User} from '../../graphql';
import {CardStyles} from '../Cards/CardStyles';
import {UserCard} from '../Cards/UserCard';

interface UserListViewProps {
  users: Array<User>;
}

export const UserListView = ({users}: UserListViewProps) => {
  const cs = CardStyles();

  return (
    <>

      <Link to="/user/new" className={cs.fabTop}>
        <Fab size="large" color="primary">Add</Fab>
      </Link>

      <Grid container spacing={2} className={cs.root}>
        {users.map((user: User) => (
          <Grid item md={4} xs={12} key={user.id}>
            <UserCard
              user={user}
              deleteUser={(id: string) => ''}/>
          </Grid>
        ))}
      </Grid>

    </>
  );
};
